import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { checkMailClientAddress, checkMailLeadAddress, createAgencyMailType, createMailClient, createMailLead, deleteAgencyMailType, fetchAgencyMailTypes, fetchMailClients, updateAgencyMailType } from "./actions";
import { MailType } from "../../models/Mail";

interface MailState {
    mailClients: any[],
    isLoading: boolean,
    error: string | null,
    agencyMailTypes: MailType[]
}

const initialState: MailState = {
    mailClients: [],
    isLoading: false,
    error: null,
    agencyMailTypes: []
}

// slice
const mailSlice = createSlice({
  name: "mails",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMailClients.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(fetchMailClients.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.isLoading = false;
        state.mailClients = action.payload;
      })
      .addCase(fetchMailClients.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(checkMailClientAddress.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(checkMailClientAddress.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        //state.incomeSources = state.incomeSources.concat(action.payload);
      })
      .addCase(checkMailClientAddress.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createMailClient.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(createMailClient.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        //state.incomeSources = state.incomeSources.concat(action.payload);
      })
      .addCase(createMailClient.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(checkMailLeadAddress.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(checkMailLeadAddress.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        //state.incomeSources = state.incomeSources.concat(action.payload);
      })
      .addCase(checkMailLeadAddress.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createMailLead.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(createMailLead.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        //state.incomeSources = state.incomeSources.concat(action.payload);
      })
      .addCase(createMailLead.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAgencyMailTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(fetchAgencyMailTypes.fulfilled, (state, action: PayloadAction<MailType[]>) => {
        state.isLoading = false;
        state.agencyMailTypes = action.payload;
      })
      .addCase(fetchAgencyMailTypes.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createAgencyMailType.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(createAgencyMailType.fulfilled, (state, action: PayloadAction<MailType>) => {
        state.isLoading = false;
        state.agencyMailTypes = state.agencyMailTypes.concat(action.payload);
      })
      .addCase(createAgencyMailType.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateAgencyMailType.pending, (state, action) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(updateAgencyMailType.fulfilled, (state, action: PayloadAction<MailType>) => {
        state.isLoading = false;
        state.error = null;
        const updatedType = action.payload;
        const updatedTypes = state.agencyMailTypes.map((type) => {
          return type.id === updatedType.id ? updatedType : type
        });
        state.agencyMailTypes = updatedTypes;
      })
      .addCase(updateAgencyMailType.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(deleteAgencyMailType.pending, (state, action) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(deleteAgencyMailType.fulfilled, (state, action: PayloadAction<MailType[]>) => {
        state.isLoading = false;
        state.error = null;
        state.agencyMailTypes = action.payload;
      })
      .addCase(deleteAgencyMailType.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default mailSlice.reducer;